
export enum PRODUCT_TYPE {
    PRODUCT = "product",
    SERVICE = "service"
}

export type ProductFieldTypes = {
    "PRODUCT_TYPE": PRODUCT_TYPE
}

// FieldTypeNames are used in SQL table definitions in order to define which marshallers should be used to marshal / unmarshal object from / to DB
export type ProductFieldTypeName = keyof ProductFieldTypes;